/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SellCardRequest as AgentApiContractSellCardRequest } from '../../models/AgentApi/Contract/sell-card-request';
import { SellCardResponse as AgentApiContractSellCardResponse } from '../../models/AgentApi/Contract/sell-card-response';

export interface ApiAgentSellCardPost$Params {

/**
 * Interface language
 */
  lang?: string;
      body?: AgentApiContractSellCardRequest
}

export function apiAgentSellCardPost(http: HttpClient, rootUrl: string, params?: ApiAgentSellCardPost$Params, context?: HttpContext): Observable<StrictHttpResponse<AgentApiContractSellCardResponse>> {
  const rb = new RequestBuilder(rootUrl, apiAgentSellCardPost.PATH, 'post');
  if (params) {
    rb.query('lang', params.lang, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AgentApiContractSellCardResponse>;
    })
  );
}

apiAgentSellCardPost.PATH = '/api/Agent/SellCard';
